import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { AccountService } from './account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class GrupoLocalNivelService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    post(grupoLocalNivel1) {
        return this.http.post(`${SCAMP_API.accountApiV1}/grupolocalnivel1`, grupoLocalNivel1, { headers: this.account.composeHeaders() });
    }
    // Grupo local
    getAllGrupoLocalNivel1() {
        return this.http.get(`${SCAMP_API.accountApiV1}/gruposlocalnivel1`, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/gruposlocalnivel1/${id}`, { headers: this.account.composeHeaders() });
    }
    delete(grupoLocalNivel1Id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/grupolocalnivel1-delete/${grupoLocalNivel1Id}`, { headers: this.account.composeHeaders() });
    }
}
GrupoLocalNivelService.ngInjectableDef = i0.defineInjectable({ factory: function GrupoLocalNivelService_Factory() { return new GrupoLocalNivelService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: GrupoLocalNivelService, providedIn: "root" });
